<template>
  <div class="ViewSentEmails">
    <div class="row" v-if="!isUserGroupAdmin">
      <view-sent-emails-filter-bar @selectedFilterObj="updateSelectedFilterObj"></view-sent-emails-filter-bar>
      <hr width="92%">
      <view-sent-emails-detail-list v-if="showSentEmailList" v-bind:viewSentEmailList="getViewSentEmailList"></view-sent-emails-detail-list>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>      
    <loader></loader> 
    <error-page v-if="isUserGroupAdmin"></error-page> 
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import ViewSentEmailsFilterBar from '@/components/emails/view_sent_emails/ViewSentEmailsFilterBar'
import ViewSentEmailsDetailsList from '@/components//emails/view_sent_emails/ViewSentEmailsDetailsList'
import CopyrightElement from '@/components/CopyrightElement'
import AlertBox from '@/components/AlertOverlay'
import ErrorPage from '@/pages/Error'
import { constants } from '@/utils/constants'
import { emailService } from '@/server-util/email-service'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      selectedFilterAllObj: null,
      viewSentEmailList: [],
      showSpinner: false,
      showSentEmailList: false
    }
  },
  components: {
    'view-sent-emails-filter-bar': ViewSentEmailsFilterBar,
    'view-sent-emails-detail-list': ViewSentEmailsDetailsList,
    'Copyright-Element': CopyrightElement,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    updateSelectedFilterObj (value) {
      this.selectedFilterAllObj = value
      // AK: as soon as we recieved obj, invoke server call to get updated view sent mail list
      this.getSentEmailList()
      // console.log('this.selectedFilterAllObj >>> ' + JSON.stringify(this.selectedFilterAllObj))
    },
    getSentEmailList: function () {
      var storeObj = this.$store
      if (
        this.selectedFilterAllObj !== null
      ) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        const formData = new FormData()
        formData.append('GroupCourseMasterId', this.selectedFilterAllObj.selectedGroupObj.GroupCourseMasterId)
        formData.append('CourseId', this.selectedFilterAllObj.selectedCohortObj.CohortId)
        if (this.selectedFilterAllObj.selectedEmailObj !== '') {
          formData.append('SenderEmail', this.selectedFilterAllObj.selectedEmailObj)
        } else {
          formData.append('SenderEmail', '')
        }
        if (this.selectedFilterAllObj.selectedTemplateObj !== '') {
          formData.append('EmailTemplate', this.selectedFilterAllObj.selectedTemplateObj.EmailTemplateName)
        } else {
          formData.append('EmailTemplate', '')
        }
        emailService
          .getViewSentEmails(
            storeObj.state.access_token, formData
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              this.viewSentEmailList = responseObj.data
              // this.showSpinner = false
              this.$store.state.isLoading = false
              if (this.viewSentEmailList.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No record found for select filter.'
                this.showSentEmailList = false
              } else {
                this.showSentEmailList = true
              }
            } else {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.showAlertDialog = true
            // this.showSpinner = false
            this.$store.state.isLoading = false
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'All Filter Obj is NULL hence declined VIEW SENT EMAIL LISTING OPERATION'
        )
      }
    }
  },
  computed: {
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    },
    getViewSentEmailList: {
      get: function () {
        return this.viewSentEmailList
      }
    }
  },
  name: 'ViewSentEmails'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ViewSentEmails {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}

.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ViewSentEmails.vue